export const MuiFabTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                borderRadius: dt.borderRadius.xLarge3,
                width: "96px",
                height: "96px",
                background: dt.color.primary.container,
                boxShadow: dt.elevation.level3,
                ".PixelIcon": {
                    width: dt.icon.size.xLarge,
                    height: dt.icon.size.xLarge,
                    backgroundColor: dt.color.onPrimary.container,
                },
                "&:hover, &:is(.Pxl-demo-hover, [data-demostate=hover])": {
                    background: dt.cta.containedSubtle.color.background.primary.hover,
                    boxShadow: dt.elevation.level3,
                },
                "&:focus-visible, &:is(.Pxl-demo-focus, [data-demostate=focus])": {
                    background: dt.cta.containedSubtle.color.background.primary.focus,
                    boxShadow: dt.elevation.level3,
                },
                "&:active, &:is(.Pxl-demo-active, [data-demostate=active])": {
                    background: dt.cta.containedSubtle.color.background.primary.pressed,
                    boxShadow: dt.elevation.level3,
                },
            },
            sizeMedium: {
                borderRadius: dt.borderRadius.xLarge2,
                width: dt.size.xLarge6,
                height: dt.size.xLarge6,
                ".PixelIcon": {
                    width: dt.icon.size.medium,
                    height: dt.icon.size.medium,
                },
            },
            sizeSmall: {
                borderRadius: dt.borderRadius.xLarge,
                width: dt.size.xLarge4,
                height: dt.size.xLarge4,
                ".PixelIcon": {
                    width: dt.icon.size.medium,
                    height: dt.icon.size.medium,
                },
            },
        },
    };
};
